// extracted by mini-css-extract-plugin
var _1 = "HomeAvatarCard__addStudentCircle--CzXqv";
var _2 = "HomeAvatarCard__addStudentRing--Nmr3J";
var _3 = "HomeAvatarCard__avatar--ztMcw";
var _4 = "HomeAvatarCard__avatarSurround--o_F3v";
var _5 = "HomeAvatarCard__avatarWrapper--SR07Q";
var _6 = "HomeAvatarCard__card--vO8uq";
var _7 = "HomeAvatarCard__cardDisabled--GvBDG";
var _8 = "HomeAvatarCard__exclamationIcon--kHlmU";
var _9 = "HomeAvatarCard__info--gf_IG";
var _a = "HomeAvatarCard__name--nAUHd";
var _b = "HomeAvatarCard__secondaryText--a7TfX";
var _c = "HomeAvatarCard__username--ynTYv";
export { _1 as "addStudentCircle", _2 as "addStudentRing", _3 as "avatar", _4 as "avatarSurround", _5 as "avatarWrapper", _6 as "card", _7 as "cardDisabled", _8 as "exclamationIcon", _9 as "info", _a as "name", _b as "secondaryText", _c as "username" }
